module.exports = __webpack_public_path__ + "img/8.495ace53.jpg";